import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import JDialog from '../alphabetbubble/JDialog';
import LetterBox from '../alphabetbubble/LetterBox';
import LetterBubble from '../alphabetbubble/LetterBubble';
import ScoreDial from '../alphabetbubble/ScoreDial';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import PopBubbleScreen from './PopBubbleScreen';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Game extends Phaser.Scene {
    static get KEY() { return 'Game'; }

    constructor() {
        super({ key: (Game).KEY });
    }

    init() {
        this.boxes = [];
        this.boxesNumbers = [];
        this.bodies = [];
        this.world = null;
        //numbers A - Z will be represented by numbers 1 - 26
        this.currentNumberQueue = [];
        this.bubbles = [];
        this.startOffset = null;
    }

    create() {
        let width = this.scale.width;

        ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._background, this).setOrigin(0);

        this.addFish();

        let sand = ABCyaPhaser.Images.addImage(this.scale.width / 2, 0, UIAssetKeys._sand, this);
        sand.y = this.scale.height - sand.height / 2;

        this.scoreDial = new ScoreDial(this, gameData.CURRENT_LEVEL);
        this.scoreDial.x = width / 2;
        this.scoreDial.y = -25;
        this.add.existing(this.scoreDial);

        this.makeLevel();

        this.needsBubbles = true;

        if (gameData.CURRENT_LEVEL == 1) {
            this.showIntroDialog();
            this.time.delayedCall(1000, this.playInstructionsSound, null, this);
        }
        else {
            this.showRound();
            this.makeBubbleLetters();
            ABCyaPhaser.Timer.addRepeatingEvent(this, 2500, this.makeBubbleLetters.bind(this), -1);
        }
    }

    addFish() {
        this.doFishMotion("fish1", -200, 300, 27400);
        this.doFishMotion("fish2", 1500, 100, 29400);
        this.doFishMotion("fish3", 1500, 200, 25400);
        this.doFishMotion("fish4", 1500, 400, 31400);
    }

    doFishMotion(spriteName, startX, startY, time) {
        let sprite = ABCyaPhaser.Images.addImage(startX, startY, spriteName, this, "piecesData2");

        let endX = -200;
        if (startX < 0) {
            endX = 1500;
        }

        ABCyaPhaser.Tweens.addTween(sprite, time, { x: endX, repeat: -1 }, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(sprite, 600, { scaleX: 1.1, scaleY: 0.9, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Linear);
    }

    makeLevel() {
        let level = gameData.CURRENT_LEVEL;

        let limit = 6;

        this.startOffset = 0;
        if (level == 1) {
            limit = 6;
            this.startOffset = 0;
        }
        else if (level == 2) {
            limit = 6;
            this.startOffset = 6;
        }
        else if (level == 3) {
            limit = 7;
            this.startOffset = 12;
        }
        else if (level == 4) {
            limit = 7;
            this.startOffset = 19;
        }

        for (let i = 0; i < limit; i++) {
            let adjustY = 0;

            switch (i) {
                case 0:
                    adjustY = -20;
                    break;
                case 1:
                    adjustY = -10;
                    break;
                case 2:
                    adjustY = 0;
                    break;
                case 3:
                    adjustY = 0;
                    break;
                case 4:
                    adjustY = -10;
                    break;
                case 5:
                    adjustY = -20;
                    break;
                case 6:
                    adjustY = -25;
                    break;
            }

            let num = i + this.startOffset;
            let box = new LetterBox(this, i + 1, num);
            box.centerContainer();
            box.x = (i * (1000 / limit)) + 70 + 80;
            box.y = this.scale.height - 125 + 40 + adjustY;
            this.add.existing(box);
            this.boxes.push(box);
        }

        //choose 3 boxes to start filled
        let randomFilled = randomUniqueArray(0, limit - 1, 3);

        let numberAlreadyFilledAnswers = 1;

        for (let i = 0; i < numberAlreadyFilledAnswers; i++) {
            let index = randomFilled[i];
            this.boxes[index].correct();
        }

        //we need to store all numbers from boxes in order to have a random number
        // to display as a 'wrong' choice when there's only 1 'chest' left to fill

        this.boxesNumbers = [];

        for (let i = 0; i < this.boxes.length; i++) {
            let box = this.boxes[i];
            this.boxesNumbers.push(box.number);
        }
    }

    showIntroDialog() {
        this.introDialog = new JDialog(this, null, UIAssetKeys._go_button, null, null, 3);
        this.introDialog.x = this.scale.width / 2;
        this.introDialog.y = this.scale.height / 2;

        this.introDialog.doAction1 = this.closeIntroDialog.bind(this);
        this.introDialog.button1.y += 135;

        this.add.existing(this.introDialog);
    }

    closeIntroDialog() {
        if (this.instructionsSound) {
            this.instructionsSound.stop();
        }
        this.showRound();
        this.makeBubbleLetters();
        ABCyaPhaser.Timer.addRepeatingEvent(this, 2500, this.makeBubbleLetters.bind(this), -1);

        this.introDialog.destroy();
    }

    showRound() {
        let roundLabel = ABCyaPhaser.Text.addText(this.scale.width / 2, this.scale.height / 2, 52, 0xffffff, FontKeys._odin_roundedregular, "Round " + gameData.CURRENT_LEVEL, this).setOrigin(0.5)
        roundLabel.alpha = 0;

        this.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(roundLabel, 200, { alpha: 1 }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(roundLabel, 800, { delay: 1000, alpha: 0 }, Phaser.Math.Easing.Linear),
                ],
            onComplete: () => roundLabel.destroy()
        });
    }

    makeBubbleLetters() {
        if (!this.needsBubbles) {
            return;
        }
        let filledCount = this.generateRandomBubbleNumbers();

        if (filledCount == this.boxes.length) {
            this.needsBubbles = false;
            this.gameOver();
            return;
        }

        let number = this.currentNumberQueue.pop();

        let bubble = new LetterBubble(this, number);
        bubble.x = this.scale.width + 20;
        bubble.y = 150;
        bubble.clickAction = this.bubbleClicked.bind(this);
        this.add.existing(bubble);
        this.bubbles.push(bubble);
    }

    generateRandomBubbleNumbers() {
        // we need to generate bubble numbers based on what
        // are left not filled
        // this should be called each time a box is filled

        let numbersNeeded = [];
        let filledCount = 0;

        for (let i = 0; i < this.boxes.length; i++) {
            let box = this.boxes[i];
            if (!box.isFilled) {
                numbersNeeded.push(box.number);
            } else {
                filledCount++;
            }
        }

        //add one random number to list so with only 1 box left, we always
        // have 1 wrong number
        let randomIndex = Phaser.Math.Between(0, this.boxesNumbers.length - 1);
        let wrongNum = this.boxesNumbers[randomIndex];
        numbersNeeded.push(wrongNum);

        // now randomize the array
        this.currentNumberQueue = Phaser.Utils.Array.Shuffle(numbersNeeded);

        return filledCount;
    }

    gameOver() {
        //remove bubbles
        for (let i = 0; i < this.boxes.length; i++) {
            let box = this.boxes[i];

            this.tweens.timeline({
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(box, 600, { delay: i * 2800, scale: 1.2, onStart: () => this.speakLetter(box.letter) }, Phaser.Math.Easing.Linear),
                        ABCyaPhaser.Tweens.createTween(box, 600, { scale: 1 }, Phaser.Math.Easing.Linear, () => this.speakIconName(box)),
                        ABCyaPhaser.Tweens.createTween(box, 600, { scale: 1.2 }, Phaser.Math.Easing.Linear),
                        ABCyaPhaser.Tweens.createTween(box, 600, { scale: 1 }, Phaser.Math.Easing.Linear),
                    ]
            });
        }

        this.time.delayedCall((this.boxes.length * 2800) + 1000, this.playCorrect, null, this);
        this.time.delayedCall((this.boxes.length * 2800) + 2000, this.cleanUp, null, this);
    }

    speakLetter(letter) {
        letter = letter.toLowerCase();

        ABCyaPhaser.Audio.playOneShot(letter + "-name", this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }

    speakIconName(box) {
        box.showWord();

        let letter = box.letter.toLowerCase();
        ABCyaPhaser.Audio.playOneShot(letter, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }

    playCorrect() {
        let choice = Phaser.Math.Between(0, 1);
        ABCyaPhaser.Audio.playOneShot(choice == 0 ? LocalizationSoundAssetKeys._nice : LocalizationSoundAssetKeys._good_job, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }

    cleanUp() {
        this.tweens.killAll();
        this.time.removeAllEvents();

        this.scene.start(PopBubbleScreen.KEY);
    }

    bubbleClicked(bubble) {
        /*drop number
        we'll generate our body from the caller (GameScreen)
        if its over the incorrect letter box that is full we initiate physics
         else we animate a drop to the empty letter box */

        // test if bubble is over a number
        let bubbleCenterX = bubble.x + bubble.getBounds().width / 2;
        let boxWidth = this.boxes[0].getHalfBoundsRect().width;

        let distanceFall = 450;
        let yAdjust = 0;
        let isOverBox = false;

        for (let i = 0; i < this.boxes.length; i++) {

            let box = this.boxes[i];
            let boxRect = box.getHalfBoundsRect();

            if (bubbleCenterX <= (boxWidth + boxRect.x - boxWidth / 2) && bubbleCenterX >= boxRect.x - boxWidth / 2) {
                isOverBox = true;

                if (!box.isFilled) {
                    if (bubble.number == box.number) {
                        ABCyaPhaser.Tweens.addTween(bubble, 1000, { y: bubble.y + distanceFall }, Phaser.Math.Easing.Linear, () => {
                            bubble.alpha = 0;
                            this.boxes[i].correct();
                        });
                    } else {
                        ABCyaPhaser.Tweens.addTween(bubble, 1000, { y: bubble.y + distanceFall }, Phaser.Math.Easing.Linear, () => {
                            bubble.alpha = 0;
                            this.boxes[i].incorrect();
                        });
                    }

                }
                else {
                    //box is filled, bounce off it
                    let x = bubble.x;
                    let y = bubble.y;

                    this.tweens.timeline({
                        tweens:
                            [
                                ABCyaPhaser.Tweens.createTween(bubble, 800, { y: distanceFall + 164 }, Phaser.Math.Easing.Linear, () => this.playBounceSound()),
                                ABCyaPhaser.Tweens.createTween(bubble, 130, { x: x + 30, y: y + 350 - yAdjust }, Phaser.Math.Easing.Linear),
                                ABCyaPhaser.Tweens.createTween(bubble, 180, { x: x + 63, y: y + 410 - yAdjust }, Phaser.Math.Easing.Linear),
                                ABCyaPhaser.Tweens.createTween(bubble, 500, { x: x + 113, y: y + 710 - yAdjust }, Phaser.Math.Easing.Linear),
                            ],
                        onComplete: () => this.removeBubble(bubble)
                    });
                }
                //end loop if we find box bubble is over
                break;
            }
        }

        //not over a numberBox -- drop through boxes
        if (!isOverBox) {
            //not over a numberBox -- drop straight down
            this.tweens.timeline({
                tweens:
                    [
                        ABCyaPhaser.Tweens.createTween(bubble, 900, { y: 620 }, Phaser.Math.Easing.Linear, () => this.playOffscreenSound()),
                        ABCyaPhaser.Tweens.createTween(bubble, 300, { y: 820 }, Phaser.Math.Easing.Linear, () => this.removeBubble(bubble)),
                    ]
            });
        }
    }

    playBounceSound() {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._number_bounce, this);
    }

    removeBubble(bubble) {
        bubble.cleanUp();
    }

    playOffscreenSound() {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._number_off_screen, this);
    }

    playInstructionsSound() {
        // need ths audio
        this.instructionsSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
        ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._pop_instructions, this.instructionsSound);
        this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.instructionsSound.destroy());
    }
}

const SCALE = 30;
const STEP = 20;
const TIMESTEP = 1 / STEP;

function randomUniqueArray(min, max, arrayLength) {
    if (arrayLength > (max - min + 1)) {
        return null;
    }

    let array = [];

    for (let i = min; i < max + 1; i++) {
        array.push(i);
    }

    let randomArray = [];

    for (let a = 0; a < arrayLength; a++) {
        let index = Phaser.Math.Between(0, array.length - 1);

        let num = array[index];
        randomArray.push(num);

        Phaser.Utils.Array.Remove(array, num);
    }

    return randomArray;
}